import ReactMapboxGl from 'react-mapbox-gl';

const Map = ReactMapboxGl({
  accessToken: 'pk.eyJ1Ijoia2VuZyIsImEiOiJialJOeHZZIn0.FhsKOrrXDsZ5lyggghMfQw'
});

export default Map;
